

import { NgModule } from '@angular/core';
import {FromtoPipe} from "./from-to/fromto.pipe";

@NgModule({
    imports: [],
    exports: [FromtoPipe],
    declarations: [FromtoPipe]
})
export class PipesModule {}
